/**
 * The type of (redux) action which signals that a virtual key was pressed
 *
 * {
 *     type: VIRTUAL_KEY_PRESSED,
 *     keyValue: String,
 * }
 */
export const UPDATE_STORE_TUTORIAL = 'UPDATE_STORE_TUTORIAL';
